import { Row } from '@tanstack/react-table';

import { formatToCurrency } from '@xemplo/common-util';
import {
  AmendmentKeypayStatusIds,
  AmendmentListItem,
  ChangeTaskTypes,
} from '@xemplo/gp-types';
import { DawnCircleInformation } from '@xemplo/icons';
import { Tooltip, TooltipPlacement } from '@xemplo/tooltip';

import * as S from '../amendments-table.styles';
export function TotalAmountCell({ row }: Readonly<{ row: Row<AmendmentListItem> }>) {
  const {
    amendmentTaskTypeId,
    amount,
    isIntegrated,
    amendmentKeypayStatusId,
    totalAmount,
  } = row.original;

  const isPayInstruction = amendmentTaskTypeId === ChangeTaskTypes.PAY_INSTRUCTION;

  if (isPayInstruction) {
    return amount ? formatToCurrency({ value: amount }) : '-';
  }

  if (totalAmount) return formatToCurrency({ value: totalAmount });

  //We only need to show pending state for amounts if the amendment is integrated and has not yet been applied to keypay
  if (
    isIntegrated &&
    amendmentKeypayStatusId !== AmendmentKeypayStatusIds.Success &&
    !totalAmount
  ) {
    return (
      <S.Pending>
        Pending
        <Tooltip
          text="Pending amounts will be available once amendment is applied in PPS (Payroll Processing Service) "
          placement={TooltipPlacement.BottomLeft}
        >
          <DawnCircleInformation height={16} width={16} />
        </Tooltip>
      </S.Pending>
    );
  }
  return formatToCurrency({ value: totalAmount });
}
